<template>
  <el-input v-model="code" :placeholder="$t('login.login.loginForm.captcha.placeholder')" @blur="captchaBlurHandler">
    <template slot="append">
      <div class="captcha-append-container">
        <span v-if="startCountdown" class="resend-countdown">{{ resendCountdown }}s</span><!--
        --><span class="btn-send-captcha font-medium" :class="{'disabled': !isSendOtpBtnAvalible}" @click="sendCodeHanlder">{{ sendOtpBtnText }}</span>
      </div>
    </template>
  </el-input>
</template>
<script>
import Cookies from 'js-cookie';
import { filterBlank } from 'common/utils.js';
import { oneApi } from 'config/api';
// import gRecaptcha from '@thinkacademy/vitas-utils/gRecaptcha';
/* eslint-disable vue/require-default-prop */

export default {
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    type: {
      type: String,
      default: 'phone',
    },
    phone: {
      type: [String, Number],
      default: '',
    },
    areaCode: {
      type: [String, Number],
      default: '',
    },
    email: {
      type: String,
      default: '',
    },
    beforeSend: Function,
    sendError: Function,
    sendSuccess: {
      type: Function,
      default: () => {},
    },
    cookieName: String,
    scene: {
      type: Number,
      default: 1,
    },
    canClick: {
      type: Boolean,
      default: true,
    },
    studentId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      startCountdown: false,
      sendOtpBtnText: this.$t('login.login.otpSendBtn.normal'),
      resendCountdown: 0,
      timer: null,
      code: '',
      sendClick: false,
    }
  },
  computed: {
    isSendOtpBtnAvalible() {
      let canSend = false
      if (this.scene === 2) {
        canSend = (!this.startCountdown && !this.sendClick);
      } else {
        canSend = (!this.startCountdown && this.canClick && !this.sendClick);
      }
      return canSend
    },
  },
  watch: {
    value(val) {
      this.code = val
    },
    code(val) {
      this.$emit('input', val)
    },
  },
  methods: {
    init() {
      clearInterval(this.timer);
      this.startCountdown = false;
      this.sendOtpBtnText = this.$t('login.login.otpSendBtn.normal');
      this.resendCountdown = 0;
      this.timer = null;
      this.code = '';
      this.sendClick = false;
    },
    sendCodeHanlder() {
      const sendFunc = () => {
        this.sendCaptcha()
      };
      if (!this.beforeSend) {
        sendFunc();
      } else if (typeof this.beforeSend === 'function') {
        this.beforeSend(sendFunc)
      }
    },
    /**
     * 发送手机验证码
     */
    async sendCaptcha() {
      if (!this.isSendOtpBtnAvalible) {
        return
      }
      this.sendClick = true;
      this.resendCountdown = Cookies.get(this.cookieName) ? parseInt(Number(Cookies.get(this.cookieName)) - (new Date().getTime() / 1000), 10) : 0
      if (this.resendCountdown !== 0) {
        // 开始倒计时
        this.sendClick = false;
        this.setIntervalFunc()
        this.sendSuccess();
        return
      }
      let data = {}
      if (this.type === 'phone') {
        data = {
          scene: this.scene,
          type: 0, // 0手机号
        }
        if (this.scene !== 2) {
          data.contactInfo = this.phone.trim()
          data.countryCallingCode = this.areaCode.trim()
        }
      } else {
        data = {
          scene: this.scene,
          type: 2, // 2邮箱
        }
        if (this.scene !== 2) {
          data.contactInfo = this.email.trim()
        }
      }
      // const { verifyKey } = process.env;
      // const token = await gRecaptcha.getToken.call(this, verifyKey)
      // this.$store.commit('verifyToken/SEND_GRC_TOKEN', token)
      this.$store.commit('verifyToken/SEND_GRC_ACTION', 'sendVerification')
      const res = await this.$axios.post(oneApi.sendLoginMobileCode, data, { rewritePostBody: true, uid: Number(this.studentId) || this.$store.state.ucenter.user.uid });
      this.sendClick = false
      if (Number(res.code) !== 0) {
        this.$ElMessage({
          type: 'error',
          message: res.msg,
        });
        if (typeof this.sendError === 'function') {
          this.sendError()
        }
        return;
      }
      this.sendSuccess();
      // 设置cookie倒计时数字
      this.resendCountdown = 60
      this.setCookie()
      // 开始倒计时
      this.setIntervalFunc()
      // this.setSendCodeBtn();
    },
    setCookie() {
      const seconds = new Date().getTime() / 1000 + 60;
      const expires = new Date(new Date() * 1 + 60 * 1000);
      Cookies.set(this.cookieName, seconds, { expires })
    },
    // 倒计时
    setIntervalFunc() {
      this.sendOtpBtnText = this.$t('login.login.otpSendBtn.reResend');
      this.startCountdown = true;
      clearInterval(this.timer)
      this.timer = setInterval(() => {
        this.resendCountdown -= 1;
        if (this.resendCountdown === 0) {
          this.startCountdown = false;
          clearInterval(this.timer)
        }
      }, 1000)
    },
    captchaBlurHandler() {
      this.value = filterBlank(this.value);
    },
  },
}
</script>
<style lang="scss" scoped>
.captcha-append-container {
  width: fit-content;
  text-align: right;

  .resend-countdown {
    display: inline-block;
    margin-right: 10px;
    width: 30px;
    font-size: 16px;
    line-height: 19px;
    color: var(--txt-color-link);
  }

  .btn-send-captcha {
    margin-right: 8px;
    font-size: 16px;
    line-height: 19px;
    color: var(--txt-color-link);
    cursor: pointer;

    &:hover {
      color: var(--txt-color-link);
    }

    &.disabled {
      color: var(--txt-color-lv2);
      cursor: not-allowed;

      &:hover {
        color: var(--txt-color-lv2);
      }
    }
  }
}
</style>
